import './index.less'
import { getMembershipPriceProductInfo, createMembershipPriceCoupon, } from "@utils/api.js"
import { Decimal } from 'decimal.js'
import { formatMoney } from '@shopify/theme-currency'
import { cookie, copyString, } from "@utils/index.js"

class ProductMembershipPrice {
  constructor() {
    // 获取 会员价 DOM
    this.DOM = document.querySelector('#app-membership-price')
    this.variantWrap = document.querySelector(".variant-input-wrap")

    if(!this.DOM) return

    const {
      displayText, id, spuTitle, variantId, variantTitle, offText, rulesText, copyText, copiedText, claimText,
      getText, codeText, loginToApplyText, copyToApplyText, clickToApplyText,
      claimCodeSuccessTipText, copyCodeSuccessTipText, invalidCouponText,
    } = this.DOM.dataset

    this.spuInfo = [] // 初始化，spu信息为空
    this.curSkuInfo = {}  // 初始化，sku信息为空
    this.displayText = displayText === 'true' // 是否是纯文案显示
    this.productId = id // SPU ID
    this.spuTitle = spuTitle // SPU title
    this.variantId = variantId // 变体 ID
    this.skuTitle = variantTitle // 变体 title
    this.discountAmount = 0 // 优惠金额

    this.i18nText = {
      offText,
      rulesText,
      copyText,
      copiedText,
      claimText,
      getText,
      codeText,
      loginToApplyText,
      copyToApplyText,
      clickToApplyText,
      claimCodeSuccessTipText,
      copyCodeSuccessTipText,
      invalidCouponText,
    }

    this.init()

    // 旧 main-product 触发variant变化 - 改变当前变体
    if(this.variantWrap) { // 就main-product
      this.variantWrap.querySelectorAll('label').forEach(item => {
        item.onclick = (e) => {
          this.variantId = e.target.dataset.productLabel
          this.curSkuInfo = this.spuInfo.find(it => it.skuId === this.variantId)

          // 更新 skuTitle
          this.skuTitle = e.target.querySelector('.goods-title').innerText

          this.initDOM()
        }
      })
    }

    // 新 main-product 触发variant变化 - 改变当前变体
    if (document.querySelector('variant-fields')) {
      document.addEventListener('variantChangeEvent', e => {
        const currentVariant = e.detail.variant
        if (currentVariant) {
          this.variantId = currentVariant.id
          this.curSkuInfo = this.spuInfo.find(it => it.skuId === this.variantId.toString())

          // 更新 skuTitle
          this.skuTitle = currentVariant.title

          setTimeout(() => {
            this.initDOM()
          }, 200)
        }
      })
    }
  }
  async init() {
    try {
      const data = await getMembershipPriceProductInfo({
        shopifyShopId: window.pageInfo.shopId,
        spuId: this.productId,
      })

      if (data?.data) {
        this.spuInfo = data.data
        this.curSkuInfo = this.spuInfo.find(it => it.skuId === this.variantId)

        // 登录成功后返回，自动获取 code 码
        if(this.curSkuInfo && window.pageInfo.customerInfo.id && sessionStorage.getItem('jk_sku_member_code')) {
          let _params = new URLSearchParams(window.location.search);
          const pendding = _params.get("pendding_member_code")
          if(pendding) {
            if (this.curSkuInfo.discountCode) {
              this.successCallback()
            } else {
              // 登录后自动复制，被浏览器禁止
              await this.updateSpuInfo(false)
            }

            // 更新 url
            _params.delete("pendding_member_code")
            const newUrl = window.location.origin + window.location.pathname + "?" + _params.toString();
            window.history.pushState({ path: newUrl }, "", newUrl);

            sessionStorage.removeItem('jk_sku_member_code')
          } else {
            sessionStorage.removeItem('jk_sku_member_code')
            this.initDOM()
          }
        } else {
          this.initDOM()
        }
      }
    } catch (err) {
      pushMessage(err.message, "warning");
      this.initDOM()
    }
  }
  // 更新 #spuInfo
  async updateSpuInfo(needCopy) {
    const coupon = await createMembershipPriceCoupon({
      shopifyShopId: window.pageInfo.shopId,
      settingId: this.curSkuInfo.benefitId,
      activeId: this.curSkuInfo.activeId,
      skuId: this.curSkuInfo.skuId,
    })

    if (coupon.data) {
      this.curSkuInfo = coupon.data
      // 更新 #spuInfo
      this.spuInfo = this.spuInfo.map(item => {
        if (item.skuId === coupon.data.skuId) {
          return coupon.data
        }
        return item
      })

      // 是否需要复制
      if (needCopy) {
        copyString(this.curSkuInfo.discountCode, () => this.successCallback())
      } else {
        this.successCallback()
      }
    }
  }
  successCallback() {
    // 提示 copy 成功
    pushSuccessMessage(this.i18nText.claimCodeSuccessTipText)
  
    // 设置 cookie
    let d = new Date()
    d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)) // 7天
    document.cookie = `discount_code=${this.curSkuInfo.discountCode};expires=${d.toGMTString()};path=/`

    this.initDOM()
  }
  initDOM() {
    if (!this.curSkuInfo || Object.keys(this.curSkuInfo)?.length === 0) {
      this.DOM.innerHTML = ''
      this.DOM.parentElement.style.display = 'none'
      this.DOM.parentElement.setAttribute('data-show', false)
      return
    }

    const {
      discountCode,  // 折扣码
      valueType,     // 折扣类型，0: 固定金额, 1: 百分比
      value,         // 折扣值
      imageType,     // 图片类型，0: 固定图片，1: 底图（数值作取值）
      imageUrl,      // 图片url
    } = this.curSkuInfo

    // 计算优惠额
    this.discountAmount = this.calcDiscountPrice({value, valueType, })

    // 渲染 会员价 DOM
    this.renderMembershipPriceDOM({ discountCode, imageType, imageUrl, })
    this.DOM.parentElement.style.display = 'block'
    this.DOM.parentElement.setAttribute('data-show', true)
  }
  renderMembershipPriceDOM({ discountCode, imageType, imageUrl, }) {
    // 文本样式
    if (this.displayText) {
      this.DOM.innerHTML = this.renderTextDOM({ discountCode, })
    }
    // 图片样式
    else {
      this.DOM.innerHTML = this.renderImgDOM({ discountCode, imageType, imageUrl, })
    }


    // 未登录
    if ($('[data-member-price-claim]').length > 0) {
      $('[data-member-price-claim]').off('click').on('click', () => {
        sessionStorage.setItem('jk_sku_member_code', this.variantId)
        let _params = new URLSearchParams(window.location.search)
        _params.set("pendding_member_code", "1")

        window?.jackeryLoginApp?.modalLogin({
          return_url: `${location.origin}${location.pathname}?${_params.toString()}`,
          register_act: 'MB-Register',
        })

        // 数据埋码
        this.GAEvent({
          position: this.spuTitle + ' # ' + this.skuTitle,
          button_name: this.i18nText.claimText,
          type: this.displayText ? 'text' : 'pic',
          status: window.pageInfo.customerInfo.id ? 'logged_in' : 'tourist',
        })
      })
    }
    

    // 已登录未领取
    if ($('[data-member-price-get]').length > 0) {
      $('[data-member-price-get]').off('click').on('click', async (e) => {
        e.target.classList.add('btn--loading')
          try {
            // 更新 #spuInfo
            await this.updateSpuInfo(true)
          } catch (err) {
            pushMessage(err.message, "warning");
          } finally {
            e.target.classList.remove('btn--loading')
          }

          // 数据埋码
          this.GAEvent({
            position: this.spuTitle + ' # ' + this.skuTitle,
            button_name: this.i18nText.getText,
            type: this.displayText ? 'text' : 'pic',
            status: window.pageInfo.customerInfo.id ? 'logged_in' : 'tourist',
          })
      })
    }
    

    // 注册 rules 点击事件
    if ($('[data-member-price-rules]').length > 0) {
      $('[data-member-price-rules]').off('click').on('click', () => {
        const popupHtml = this.renderRulesDOM()
    
        window.ZModle.getInstance(popupHtml, {
            id: `membership-price-rules-popup-${this.curSkuInfo.skuId}`,
            class: "membership-price-popup-wrap",
            cb: () => {
                
            }
        })

        // 数据埋码
        this.GAEvent({
          position: this.spuTitle + ' # ' + this.skuTitle,
          button_name: this.i18nText.rulesText,
          type: this.displayText ? 'text' : 'pic',
          status: window.pageInfo.customerInfo.id ? 'logged_in' : 'tourist',
        })
      })
    }

    // 注册 copy 事件
    if ($('[data-member-price-copy]').length > 0) {
      $('[data-member-price-copy]').off('click').on('click', (e) => {
        this.registerCopyEvent(e, true)
      })
    }
    if ($('[data-member-price-code]').length > 0) {
      $('[data-member-price-code]').off('click').on('click', (e) => {
        this.registerCopyEvent(e, false)
      })
    }
  }
  // 注册 copy 事件
  registerCopyEvent(e, needSetCookie) {
    const { code, } = e.target.dataset
    if (code) {
      copyString(code, () => {
        // 是否需要 set cookie
        if (needSetCookie) {
          // 提示 copy 成功
          pushSuccessMessage(this.i18nText.claimCodeSuccessTipText)

          // 设置 cookie
          let d = new Date()
          d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)) // 7天
          document.cookie = `discount_code=${code};expires=${d.toGMTString()};path=/`

          // 更新文案
          e.target.innerText = this.i18nText.copiedText
        } else {
          // 提示 copy 成功
          pushSuccessMessage(this.i18nText.copyCodeSuccessTipText)
        }
      })
    }

    // 最新的 code 码
    const cookieCode = cookie.get('discount_code')

    // 数据埋码
    this.GAEvent({
      position: this.spuTitle + ' # ' + this.skuTitle,
      button_name: needSetCookie ? cookieCode === code ? this.i18nText.copiedText : this.i18nText.copyText : 'coupon_code',
      type: this.displayText ? 'text' : 'pic',
      status: window.pageInfo.customerInfo.id ? 'logged_in' : 'tourist',
    })
  }
  // 纯文本
  renderTextDOM({ discountCode, }) {
    // 最新的 code 码
    const cookieCode = cookie.get('discount_code')

    // 已登录
    if (window.pageInfo.customerInfo.id) {
      const tip =
        discountCode
          ? `${this.i18nText.copyToApplyText.replace('{code}', `<span class="underline underline-offset-2 cursor-pointer" data-member-price-code  data-code="${discountCode}">${discountCode}</span>`).replace('{price}', this.discountAmount)}`
          : `${this.i18nText.clickToApplyText.replace('{price}', this.discountAmount)}`

      return `
        <div class="flex items-start justify-start flex-col gap-y-30 my-35 lg:j-gap-y-14 lg:j-my-30 xl:a-gap-y-14 xl:a-my-30">
          <p class="w-full font-normal text-#666 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24 ${!discountCode ? 'lg:j-gap-x-40 xl:a-gap-x-40 flex items-center justify-start' : ''}">
            <span
              class="font-normal text-#666 text-26 leading-42 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24"
            >${tip}</span>
            ${
              !discountCode
                ? `
                  <button
                    class="member-price-text-btn hidden lg:block appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16"
                    data-member-price-get
                  >
                    ${this.i18nText.getText}
                  </button>
                `
                : ''
            }
          </p>
          ${
            discountCode
             ? `
              <div class="w-full flex-between lg:flex-start lg:j-gap-x-50 xl:a-gap-x-50">
                <span class="text-#666 font-medium leading-none underline underline-offset-2 lg:j-text-16 xl:a-text-16 cursor-pointer" data-member-price-rules>
                  ${this.i18nText.rulesText}
                </span>
                <button
                  class="appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16"
                  data-member-price-copy
                  data-code="${discountCode}"
                >
                  ${cookieCode === discountCode ? this.i18nText.copiedText : this.i18nText.copyText}
                </button>
              </div>
             `
             : `
              <div class="lg:hidden w-full flex items-center justify-end lg:flex-start lg:j-gap-x-50 xl:a-gap-x-50">
                <button
                  class="member-price-text-btn appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16"
                  data-member-price-get
                >
                  ${this.i18nText.getText}
                </button>
              </div>
             `
          }
        </div>
      `
    }

    // 未登录
    const tip = `${this.i18nText.loginToApplyText.replace('{price}', this.discountAmount)}`
    return `
      <div class="flex items-start justify-start flex-col gap-y-30 my-35 lg:j-gap-y-14 lg:j-my-30 xl:a-gap-y-14 xl:a-my-30 cursor-pointer" data-member-price-claim>
        <p class="w-full font-normal text-#666 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24 lg:j-gap-x-40 xl:a-gap-x-40 flex items-center justify-start">
          <span class="font-normal text-#666 text-26 leading-42 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24">${tip}</span>
          <button class="hidden lg:block appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16">${this.i18nText.claimText}</button>
        </p>
        <div class="lg:hidden w-full flex items-center justify-end lg:flex-start lg:j-gap-x-50 xl:a-gap-x-50">
          <button class="appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16">${this.i18nText.claimText}</button>
        </div>
      </div>
    `
  }
  renderImgDOM({ discountCode, imageType, imageUrl, }) {
    // 已登录
    if (window.pageInfo.customerInfo.id) {
      // 最新的 code 码
      const cookieCode = cookie.get('discount_code')

      return `
        <div
          class="flex-between w-629 h-202 mt-40 mb-70 lg:a-w-346 lg:a-h-112 lg:j-mt-10 lg:j-mt-20 lg:j-mb-35 xl:a-w-346 xl:a-h-112 xl:a-mt-20 xl:a-mb-35"
          style="background: white url(${imageUrl}) center center /contain no-repeat;"
        >
          <div class="flex-center flex-col w-414 gap-y-12 lg:j-w-228 lg:j-gap-y-8 xl:a-w-228 xl:a-gap-y-8 ${imageType === 0 ? 'pt-105 lg:j-pt-60 xl:a-pt-60' : 'pt-15 lg:j-pt-10 xl:a-pt-10'}">
            ${
              imageType === 0
                ? ''
                : `
                  <div class="flex items-baseline">
                    <em class="text-#FE7704 not-italic font-bold leading-none text-80 lg:j-text-44 xl:a-text-44">${this.discountAmount}</em>
                    <span class="text-#FE7704 font-bold leading-none text-26 ml-5 lg:j-text-14 lg:j-mb-5 lg:j-ml-5 xl:a-text-14 xl:a-mb-5 xl:a-ml-5">${this.i18nText.offText}</span>
                  </div>
                `
            }
            ${
              discountCode
                ? `
                  <div class="flex-between gap-x-40 lg:j-gap-x-20 xl:a-gap-x-20">
                    <span class="font-medium text-#FDA71A leading-none underline underline-offset-2 text-22 lg:j-text-12 xl:a-text-12 cursor-pointer" data-member-price-code data-code="${discountCode}">${this.i18nText.codeText}:${discountCode}</span>
                    <span class="font-medium text-#FDA71A leading-none underline underline-offset-2 text-22 lg:j-text-12 xl:a-text-12 cursor-pointer" data-member-price-rules>${this.i18nText.rulesText}</span>
                  </div>
                `
                : ''
            }
          </div>
          ${
            discountCode
              ? `
                <div class="flex-center w-215 pt-15 lg:j-w-118 lg:j-pt-10 xl:a-w-118 xl:a-pt-10">
                  <button
                    class="rounded-full bg-primary font-semibold text-#FFFDF6 min-w-150 h-64 text-26 leading-none lg:j-min-w-82 lg:j-h-36 lg:j-text-14 lg:j-px-10 xl:a-min-w-82 xl:a-h-36 xl:a-text-14 xl:a-px-10"
                    data-member-price-copy
                    data-code="${discountCode}"
                  >
                    ${cookieCode === discountCode ? this.i18nText.copiedText : this.i18nText.copyText}
                  </button>
                </div>
              `
              : `
                <div class="flex-center w-215 pt-15 lg:j-w-118 lg:j-pt-10 xl:a-w-118 xl:a-pt-10">
                  <button
                    class="flex-center rounded-full bg-primary font-semibold text-#FFFDF6 min-w-150 h-64 text-26 leading-none lg:j-min-w-82 lg:j-h-36 lg:j-text-14 lg:j-px-10 xl:a-min-w-82 xl:a-h-36 xl:a-text-14 xl:a-px-10"
                    data-member-price-get
                  >
                    ${this.i18nText.getText}
                  </button>
                </div>
              `
          }
        </div>
      `
    }

    // 未登录
    return `
      <div
        class="flex-between w-629 h-202 mt-40 mb-70 lg:a-w-346 lg:a-h-112 lg:j-mt-10 lg:j-mt-20 lg:j-mb-35 xl:a-w-346 xl:a-h-112 xl:a-mt-20 xl:a-mb-35 cursor-pointer"
        style="background: white url(${imageUrl}) center center /contain no-repeat;"
        data-member-price-claim
      >
        <div class="flex-center flex-col w-414 gap-y-12 lg:j-w-228 lg:j-gap-y-8 xl:a-w-228 xl:a-gap-y-8">
          ${
            imageType === 0
              ? ''
              : `
                <div class="flex items-baseline">
                  <em class="text-#FE7704 not-italic font-bold leading-none text-80 lg:j-text-44 xl:a-text-44">${this.discountAmount}</em>
                  <span class="text-#FE7704 font-bold leading-none text-26 ml-5 lg:j-text-14 lg:j-mb-5 lg:j-ml-5 xl:a-text-14 xl:a-mb-5 xl:a-ml-5">${this.i18nText.offText}</span>
                </div>
              `
          }
        </div>
        <div class="flex-center w-215 pt-15 lg:j-w-118 lg:j-pt-10 xl:a-w-118 xl:a-pt-10">
          <button class="rounded-full bg-primary font-semibold text-#FFFDF6 min-w-150 h-64 text-26 leading-none lg:j-min-w-82 lg:j-h-36 lg:j-text-14 lg:j-px-10 xl:a-min-w-82 xl:a-h-36 xl:a-text-14 xl:a-px-10">
            ${this.i18nText.claimText}
          </button>
        </div>
      </div>
    `
  }
  // 计算优惠价格
  calcDiscountPrice({value, valueType}) {
    // 固定减免金额
    if (valueType === 0) {
      const priceStr = formatMoney(new Decimal(value).mul(100).toNumber(), window.pageInfo.currency.money_format)
      return priceStr.replace(/\.00$|,00$/, '')
    }

    // 百分比减免
    return value + '%'
  }
  renderRulesDOM() {
    const { ruleInfo, imageType, imageUrl, } = this.curSkuInfo
    return `
      <div
        class="flex-between w-470 h-144 lg:a-w-346 lg:a-h-112 xl:a-w-346 xl:a-h-112"
        style="background: white url(${imageUrl}) center center /contain no-repeat;"
      >
        <div class="flex-center flex-col w-310 gap-y-12 lg:j-w-228 lg:j-gap-y-8 xl:a-w-228 xl:a-gap-y-8">
          ${
            imageType === 0
              ? ''
              : `
                <div class="flex items-baseline">
                  <em class="text-#FE7704 not-italic font-bold leading-none text-60 lg:j-text-44 xl:a-text-44">${this.discountAmount}</em>
                  <span class="text-#FE7704 font-bold leading-none text-20 ml-5 lg:j-text-14 lg:j-mb-5 lg:j-ml-5 xl:a-text-14 xl:a-mb-5 xl:a-ml-5">${this.i18nText.offText}</span>
                </div>
              `
          }
        </div>
      </div>
      <h3 class="font-semibold text-#1A1A1A leading-none text-36 mt-30 mb-15 lg:j-text-20 lg:j-my-15 xl:a-text-20 xl:a-my-15">${this.i18nText.rulesText}</h3>
      <div class="font-normal text-#666 text-28 leading-42 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24">${ruleInfo}</div>
    `
  }

  // 数据埋码
  GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"membership_price_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        "module": "Product Detail",
        ...params
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // 会员价
  new ProductMembershipPrice()
})
